import React from 'react';
import './Avatar.css';

const Avatar = ({ name, position, fav_number, foot, profilePicture, omitBackground = false}) => {

  return (
    <div className="fut-player-card" >
          <div className="player-card-bottom">
          <div className="player-info">
            <div className="player-name">
              <span>{name}</span>
            </div>
            
          </div>
      </div>

      <div className="player-card-top">
        <div className="player-master-info">
          <div className="player-rating">
            <span>{fav_number}</span>
          </div>
          <div className="player-position">
            <span>{ position  }</span>
          </div>
          <div className="player-Foot">
            <span>{ foot === 'right' ? 'R': 'L'} </span>
          </div>
          {/* <div className="player-nation">
            <img
              src="https://selimdoyranli.com/cdn/fut-player-card/img/argentina.svg"
              alt="Argentina"
              draggable="false"
            />
          </div>
          <div className="player-club">
            <img
              src="https://selimdoyranli.com/cdn/fut-player-card/img/barcelona.svg"
              alt="Barcelona"
              draggable="false"
            />
          </div> */}
        </div>

  

        <div className="player-picture">
          <img
            // src="https://selimdoyranli.com/cdn/fut-player-card/img/messi.png"
            src= {profilePicture}
            style={{
              width: '150px',
              height: '130px',
              // marginTop: '25px',
              marginLeft: '20px',
              objectFit: 'contain',
            }}
            
            alt="pic"
            draggable="false"
          />
          {/* <div className="player-extra">
            <span>4*SM</span>
            <span>4*WF</span>
          </div> */}
        </div>
      </div>


    </div>
  );
};

export default Avatar;
